<template>
  <section class="section">
    <h2 class="title">{{ t('appStore.informationTitle') }}</h2>

    <div v-for="row in appData.information" :key="row.labelKey" class="info-row">
      <span class="label">{{ t(informationRowKey(row.labelKey)) }}</span>
      <span class="value" :class="{ muted: row.expandable }"  v-if="row.labelKey == 'provider'">
        {{  t('donwload.appName') }}
        <van-icon v-if="row.expandable" name="arrow-down" size="14" color="#9ca3af" />
      </span>
      <span class="value" :class="{ muted: row.expandable }" v-else>
        {{ resolveValue(row) }}
        <van-icon v-if="row.expandable" name="arrow-down" size="14" color="#9ca3af" />
      </span>
    </div>

    <div v-for="link in appData.externalLinks" :key="link.i18nKey" class="link-row">
      <span class="link-text">{{ t(informationLinkKey(link.i18nKey)) }}</span>
      <van-icon :name="link.icon" size="16" color="#4b5563" />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { appData } from '@/lib/app-data';
import { informationLinkKey, informationRowKey } from '../i18n-keys';

const { t } = useI18n();

function resolveValue(row: (typeof appData.information)[number]): string {
  if (row.value !== undefined) return row.value;
  if (!row.valueKey) return '';
  return t(`appStore.${row.valueKey}`);
}
</script>

<style scoped>
.section {
  padding: 24px 16px 0;
}

.title {
  margin: 0 0 12px;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.info-row,
.link-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #e5e7eb;
}

.label {
  font-size: 14px;
  color: #6b7280;
}

.value {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: #111827;
  text-align: right;
}

.value.muted {
  color: #6b7280;
}

.link-text {
  font-size: 15px;
  color: #007AFF;
}
</style>
